import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import SmartCard from '../../../shared/components/SmartCard';
import AppointmentForm from './Form';
import { saveNotes } from '../../../shared/queries/Appointment';
import GraphQL from '../../../GraphQL';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import { getResponsibleStudentWithdrawByStudentId } from '../../../shared/queries/ResponsibleStudentRelation';
import { getUniformed, updatePendency } from '../../../shared/utils/smartutils';

const AppointmentFormHandler = (props) => {
  const { t, history, dispatch } = props;
  const [responsibles, setResponsibles] = useState([]);

  function backClickHandler() {
    history.push('/minime/apontamento');
  }

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const loadResponsibleStudentByStudentId = (studentId) => {
    const query = getResponsibleStudentWithdrawByStudentId(studentId);
    GraphQL(query, {})
      .then(({ responsibleStudentRelationListByStudentWithdraw }) => {
        const responsiblesStudent =
          responsibleStudentRelationListByStudentWithdraw.map(
            (responsible) => ({
              ...responsible,
              ...responsible.responsible,
            })
          );
        responsiblesStudent.push(getUniformed(t));
        setResponsibles(responsiblesStudent);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleSubmit = (values) => {
    showLoading();
    const mutation = saveNotes(values);
    GraphQL(mutation, {})
      .then((res) => {
        if (res.saveNotes) {
          hideLoading();
          backClickHandler();
          showNotificationAutoDestroy(
            'success',
            t('success.title'),
            t('success.successfully-saved')
          );
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        updatePendency(dispatch);
      });
  };

  return (
    <SmartCard title={t('mnt_appointment.title')}>
      <AppointmentForm
        backHandler={backClickHandler}
        onSubmit={handleSubmit}
        dispatch={dispatch}
        responsibles={responsibles}
        loadResponsibleStudentByStudentId={loadResponsibleStudentByStudentId}
      />
    </SmartCard>
  );
};

AppointmentFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(AppointmentFormHandler)
);
